export class WebhookV1StandardPayloadSnapshotUserProtectionArguments {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotArguments",
            "baseName": "snapshotArguments",
            "type": "WebhookV1SnapshotArguments",
            "format": ""
        },
        {
            "name": "initiatorArguments",
            "baseName": "initiatorArguments",
            "type": "WebhookV1InitiatorArguments",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WebhookV1StandardPayloadSnapshotUserProtectionArguments.attributeTypeMap;
    }
    constructor() {
    }
}
